import { Button, TableItem } from 'components/atoms';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { useTranslation } from 'react-i18next';
import { PiUserPlus } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetAuthUsersList } from 'services/auth/usersList';
import { IAuthUserListItem } from 'services/auth/types';
import { INodes } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getNodes } from 'utils/table/nodes.utils';

enum USERS_COLUMNS {
  nickname,
  firstName,
  lastName,
  email,
}

const Users = () => {
  const { data: users, isLoading } = useGetAuthUsersList();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columnsVisibility = useTableColumnsVisibility(
    'AuthUsersList',
    USERS_COLUMNS
  );

  const tableData: INodes<IAuthUserListItem> = getNodes(users);

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t('user.title.list')}
          customBackItem={<div />}
          topbarContent={
            <>
              <Table.CustomColumnsButton
                columns={USERS_COLUMNS}
                isClear
                visibility={columnsVisibility}
                i18nextPrefix=''
                customI18next='input.label'
              />
              <Button
                variant={BUTTON_VARIANT.submit}
                onClick={() => navigate('create', { replace: false })}>
                <Button.Text text={t('button.add')} />
                <Button.Icon icon={<PiUserPlus />} />
              </Button>
            </>
          }
        />
      }>
      <Table<IAuthUserListItem>
        id={columnsVisibility.tableId}
        data={tableData}
        loading={isLoading}
        columns={[
          {
            label: t('input.label.nickname'),
            renderCell: ({ userName }) => (
              <TableItem>
                <TableItem.Text text={userName} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(USERS_COLUMNS.nickname),
          },
          {
            label: t('input.label.firstName'),
            renderCell: ({ firstName }) => (
              <TableItem>
                <TableItem.Text text={firstName} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(USERS_COLUMNS.firstName),
          },
          {
            label: t('input.label.lastName'),
            renderCell: ({ lastName }) => (
              <TableItem>
                <TableItem.Text text={lastName} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(USERS_COLUMNS.lastName),
          },
          {
            label: t('input.label.email'),
            renderCell: ({ email }) => (
              <TableItem>
                <TableItem.Text text={email} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(USERS_COLUMNS.email),
          },
        ]}
      />
    </TopbarPage>
  );
};

export default Users;
